import * as React from "react";
import * as d3 from "d3";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Slider from "@material-ui/core/Slider";
import Input from "@material-ui/core/Input";
import DeleteIcon from "@material-ui/icons/Delete";
import IconButton from "@material-ui/core/IconButton";
import { GraphPredictContext } from "../../Canvas/GraphPredictContext";
import { histogramPredictionDataset } from "../../../Globals/Globals";
interface HistogramToolBarProps {
  id: string;
  masterid: string;
  style: {};
  
}
const useStyles = makeStyles({
  root: {
    width: 250,
    height: 40
  },
  input: {
    width: 32
  }
});

const HistogramToolBar: React.FC<HistogramToolBarProps> = ({
  id,
  masterid,
  style
}) => {
  const classes = useStyles({});
  const {histogramOptions, sethistogramOptions} = GraphPredictContext();
  const [valueSideBar, setvalueSideBar] = React.useState(
    histogramOptions["graphBins"]
  );

  const handleSliderChange = (event, newValue) => {
   

    histogramPredictionDataset.removePrediction(masterid + "_predictRect");

    histogramOptions["graphBins"] = newValue;
    const Options = { ...histogramOptions };
   

    setvalueSideBar(newValue);
    sethistogramOptions(Options);
  };



  const handleInputChange = event => {
    var valueChange: number;
    if (event.target.value === "") {
      valueChange = 5;
    } else {
      valueChange = Number(event.target.value);
    }
    histogramPredictionDataset.removePrediction(masterid + "_predictRect");
    histogramOptions["graphBins"] = valueChange;
    const Options = { ...histogramOptions };
    sethistogramOptions(Options);
    setvalueSideBar(valueChange);
  };

  var toolbox: any = (
    <div className={classes.root +" "+masterid+"_menu3"} style={style}>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs>
          <Slider
            value={typeof valueSideBar === "number" ? valueSideBar : 0}
            onChange={handleSliderChange}
            aria-labelledby="input-slider"
            step={1}
            marks
            min={5}
            max={15}
          />
        </Grid>
        <Grid item>
          <Input
            className={classes.input}
            value={valueSideBar}
            margin="dense"
            onChange={handleInputChange}
            inputProps={{
              step: 1,
              min: 5,
              max: 15,
              type: "number",
              "aria-labelledby": "input-slider"
            }}
          />
        </Grid>
     
      </Grid>
    </div>
  );

  return <>{toolbox}</>;
};
export default HistogramToolBar;
